import { Navigate, Outlet } from 'react-router-dom';

const AdminRoute = ({ element }) => {
    const role = localStorage.getItem('role');

    // Check if the user is an admin
    if (role != 'admin' && role != 'superadmin') {
        return <Navigate to="/" />;
    }

    return element;
};

export default AdminRoute;
